import {
  API_ROUTES,
  API_ROUTE_V2_PREFIX,
  IPageRequestParams,
  resolveCmpForApiRequest,
} from "@tm/api-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getCommonLandingPageDetails = async (
  reqData: IPageRequestParams
) => {
  const { partner, headers, cmp, query, dvid } = reqData;
  const headerCmp = resolveCmpForApiRequest(cmp, query);

  const params = {
    lob: "standalone",
    authV2: "true",
    ...query,
  };

  const urlParams = setURLQueryParams(params);

  const response = await API_HTTP.get(
    `${API_ROUTE_V2_PREFIX}/${partner}/${
      API_ROUTES.GET_ENTRYPOINT_LANDING_PAGE_DATA
    }${urlParams ? `?${urlParams}` : ""}`,
    {
      headers: { ...headers, cmp: headerCmp || "fallback", dvid },
    }
  );
  return response;
};
